import React from 'react'
import Box from '@mui/material/Box'
import HMapInstructionTop from './HMapInstructionTop'
import HMapInstructionBottom from './HMapInstructionBottom'

const HMapInstructionPanel = ({ setCurrentPanel }) => {
  return (
    <Box
      sx={{
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '0 15px',
        width: '100%'
      }}
    >
      <HMapInstructionTop />
      <HMapInstructionBottom setCurrentPanel={setCurrentPanel} />
    </Box>
  )
}

export default React.memo(HMapInstructionPanel)
